import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { commitApiStore, commitStore, useScreen } from "@/hooks";
import { FlexBox } from "@/components/common/display";
import IconButton from "./IconButton.vue";


/**
 * Renders buttons for undoing and redoing changes.
 */
const __default__ = {
  name: "CommitButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { smallWindow } = useScreen();

return (_ctx: any,_cache: any) => {
  return (!_unref(smallWindow))
    ? (_openBlock(), _createBlock(_unref(FlexBox), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(IconButton, {
            tooltip: "Undo changes",
            icon: "undo",
            color: "primary",
            disabled: !_unref(commitStore).canUndo,
            "data-cy": "button-nav-undo",
            onClick: _unref(commitApiStore).handleUndo
          }, null, 8, ["disabled", "onClick"]),
          _createVNode(IconButton, {
            tooltip: "Redo changes",
            icon: "redo",
            color: "primary",
            "data-cy": "button-nav-redo",
            disabled: !_unref(commitStore).canRedo,
            onClick: _unref(commitApiStore).handleRedo
          }, null, 8, ["disabled", "onClick"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})